import type { Control, FieldValues, Path } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { Checkbox } from '~/components/ui/checkbox'
import { FormControl, FormField, FormItem, FormMessage } from '~/components/ui/form'
import { legalUrl } from '~/helpers/legal/legal-urls'

type Props<T extends FieldValues> = { control: Control<T>, name: Path<T> }

/**
 * Acceptation des CGV et des CGU à l'inscription (#360). Les liens ouvrent les
 * pages publiées dans un nouvel onglet : le formulaire en cours n'est pas perdu.
 */
function SignupTermsField<T extends FieldValues>({ control, name }: Props<T>) {
  const { i18n } = useTranslation()
  const link = (page: 'TERMS_OF_SALE' | 'TERMS_OF_USE') => (
    // eslint-disable-next-line jsx-a11y/anchor-has-content -- le texte du lien est fourni par <Trans>
    <a href={legalUrl(page, i18n.language)} target="_blank" rel="noopener noreferrer" className="font-medium text-foreground underline underline-offset-2" />
  )

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <div className="flex items-start gap-3">
            <FormControl>
              <Checkbox
                id={name}
                aria-required
                className="mt-0.5"
                checked={field.value === true}
                onChange={event => field.onChange(event.target.checked)}
                onBlur={field.onBlur}
                ref={field.ref}
              />
            </FormControl>
            <label htmlFor={name} className="text-sm text-muted-foreground">
              <Trans i18nKey="signup.form.terms" components={{ cgv: link('TERMS_OF_SALE'), cgu: link('TERMS_OF_USE') }} />
            </label>
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

export default SignupTermsField
